import './admin'
import '../scss/app.scss';
import 'jquery-migrate';
import '@popperjs/core';
import 'bootstrap';
import initializeLayout from './templates/initializeLayout';
import initializeFrontpage from './templates/initializeFrontPage';
import styleFrontPage from './templates/styleFrontPage';
import useJqueryGlobal from './lib/resource-global';
import makeTablesScrollable from '../templates/inc/view/content/content';
import '../../../platform/widgets/view/index';
import addMercureInboxListener from "./lib/mercureInboxListener";

useJqueryGlobal();
initializeLayout();
initializeFrontpage();
styleFrontPage();
makeTablesScrollable();

window.addEventListener('DOMContentLoaded', () => {
    window.jQuery('[data-toggle="tooltip"]').tooltip();

    if (document.querySelector('html')?.getAttribute('data-mercure-prefix')) {
        addMercureInboxListener();
    }

    // Remove elements if there is an ongoing maintenance period
    const frontpageWrapper: HTMLDivElement = document.querySelector('.frontpage-wrapper');
    const isMaintenance: boolean = Boolean(frontpageWrapper?.dataset.isMaintenance);
    if (!isMaintenance) {
        return;
    }

    const loginBox = document.querySelector('.plf-login-box');
    loginBox.remove();
});
